<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'AGREEMENT.AGREEMENT_TEMPLATE_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddAgreementTemplate">
          <button mat-raised-button class="btn btn-primary" (click)="addAgreementTemplate()">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>Add Template</span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
          <mat-cell *matCellDef="let template">
            {{ template.id }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchID">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>ID</mat-label>
              <input matInput [placeholder]="'ID'" [(ngModel)]="searchIDInput" />
              <button
                *ngIf="searchIDInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchIDInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let template">
            {{ template.name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Name</mat-label>
              <input matInput [placeholder]="'Name'" [(ngModel)]="searchNameInput" />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
          <mat-cell *matCellDef="let template">
            {{ template.type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Type</mat-label>
              <input matInput [placeholder]="'Type'" [(ngModel)]="searchTypeInput" />
              <button
                *ngIf="searchTypeInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchTypeInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</mat-header-cell>
          <mat-cell *matCellDef="let template">
            {{ template.created | date : 'MM-dd-yy, h:mm a' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDateCreated">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Date Created</mat-label>
              <input
                matInput
                [(ngModel)]="searchDateCreatedInput"
                [matDatepicker]="searchDateCreatedPicker"
                [placeholder]="'Date Created'"
              />
              <button
                *ngIf="searchDateCreatedInput"
                matSuffix
                mat-icon-button
                (click)="searchDateCreatedInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle
                *ngIf="!searchDateCreatedInput"
                matSuffix
                [for]="searchDateCreatedPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchDateCreatedPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <ng-template ngxPermissionsOnly="canViewAgreementTemplate">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Template"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewTemplate(template)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditAgreementTemplate">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Template"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editTemplate(template, true)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteAgreementTemplate">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Template"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteTemplate(template)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              type="button"
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light w-50 m-1"
              (click)="resetSearchBar($event)"
            >
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
